import { gql } from '@apollo/client';

/* ── exchange traded funds ──────────────────────────────────── */

/**
 * The ETF master, paged.
 *
 * A third security universe beside schemes and stocks, and the one a model can
 * hold without any argument about what it is: an ETF already carries a SEBI
 * category of its own (Gold ETF, Silver ETF, Index Fund), so it drops into a
 * model's asset-class / category structure unchanged.
 *
 * `skip` and `limit` are both non-null on the resolver, so neither is
 * defaulted away here.
 */
export const GET_ALL_ETFS = gql`
  query GetAllEtfs($skip: Int!, $limit: Int!, $category: String) {
    getAllEtfs(skip: $skip, limit: $limit, category: $category) {
      securitySymbol
      schemeName
      category
      fundType
      fundRiskLevel
      nav
      aum
      expenseRatio
      return1yr
      return5yr
    }
  }
`;
